import Icon from '../components/Icon.vue'

Icon.register({"play":{"width":448,"height":512,"paths":[{"d":"M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464C0 501.5 40.7 524.1 72.4 505.3L424.4 297.3C455.8 278.8 455.9 233.2 424.4 214.7z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/play.js
// module id = null
// module chunks = 